import React from 'react';

import Image from '../image';

import homeTitleStyles from './home-title.module.css';

const HomeTitle = () => (
  <header className={homeTitleStyles.wrapper}>
    <Image alt="En 2-2" className={homeTitleStyles.title} path="title.jpg" />
    <Image
      alt="Des recettes de fast good à faire chez soi."
      className={homeTitleStyles.baseline}
      path="baseline.png"
    />
  </header>
);

export default HomeTitle;
